import CreateIcon from '@mui/icons-material/Create';
import Paper from '@mui/material/Paper';
import Text from '../Text';
import CustomTextField from './CustomTextField';
import {
  validateRecordName,
  validateRecordURL,
} from '../../../services/util/editChecks';
import ITooltip from '../ITooltip';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  buttonDiv: {
    alignSelf: 'flex-end',
    display: 'flex',
  },
  root: {
    position: 'relative',
    margin: '0 10px 10px 0',

    '& .MuiFormControl-root': {
      margin: '10px 0 5px',
      width: '100%',
    },
    '& .MuiInputBase-input': {
      padding: 0,
    },
    '& a': {
      textDecoration: 'underline',
    },
  },
  fieldRoot: {
    border: `1px solid rgba(0, 0, 0, 0.23)`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    borderRadius: '4px',
    display: 'flex',
    height: '22px',
    justifyContent: 'space-between',
    padding: '0 5px',

    '& a': {
      display: 'inline-block',
      width: '95%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },

    '& p': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      width: '280px',
      height: '100%',
      textOverflow: 'ellipsis',
    },

    '& svg': {
      display: 'none',
      width: '15px',
    },

    '&:hover': {
      borderColor: 'rgb(26, 115, 232)', ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
      cursor: 'pointer',

      '& svg': {
        display: 'block',
      },
    },
  },
  popupRoot: {
    display: 'flex',
    flexDirection: 'column',
    padding: '14px 18px',
  },
  paper: {
    position: 'absolute',
    zIndex: 2,
    backgroundColor: 'white', ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    width: '300px',
  },
});

const DocumentEditor = ({
  documentName,
  documentLink,
  setDocumentName,
  setDocumentLink,
  onEditMode,
  originalDocumentName,
  originalDocumentLink,
}) => {
  const [editorIsOpen, setEditorIsOpen] = useState();
  const [hasError, setHasError] = useState(false);
  const classes = useStyles();

  const openHandler = () => {
    setEditorIsOpen(true);
  };

  const cancelHandler = () => {
    // Reset input when the popup is closed by cancel
    setDocumentLink({ ...documentLink, value: originalDocumentLink });
    setDocumentName({ ...documentName, value: originalDocumentName });
    setEditorIsOpen(false);
  };

  const saveHandler = () => {
    setEditorIsOpen(false);
  };

  useEffect(() => {
    const documentNameHasError = validateRecordName(documentName.value);
    const documentLinkHasError = validateRecordURL(documentLink.value);
    if (documentNameHasError || documentLinkHasError) setHasError(true);
    else setHasError(false);
  }, [documentName, documentLink]);

  return (
    <div className={classes.root}>
      {onEditMode ? (
        <>
          <div className={classes.fieldRoot} onClick={openHandler}>
            <p>{documentName.value}</p>
            <CreateIcon />
          </div>

          {editorIsOpen && (
            <Paper className={classes.paper} elevation={3}>
              <div className={classes.popupRoot}>
                <Text type='subHeading'>Edit Document</Text>
                <CustomTextField
                  placeholder={'No description to show'}
                  input={documentName}
                  onChange={setDocumentName}
                  onEditMode={true}
                  validator={validateRecordName(documentName.value)}
                />
                <CustomTextField
                  placeholder={'No description to show'}
                  input={documentLink}
                  onChange={setDocumentLink}
                  onEditMode={true}
                  validator={validateRecordURL(documentLink.value)}
                />

                <div className={classes.buttonDiv}>
                  <ITooltip content='Cancel' placement='top'>
                    <IconButton aria-label='Cancel' onClick={cancelHandler} style={{ padding: 12 }}>
                      {' '}
                      <CloseIcon />{' '}
                    </IconButton>
                  </ITooltip>

                  <ITooltip content='Save' placement='top'>
                    <IconButton aria-label='Save' disabled={hasError} onClick={saveHandler} style={{ padding: 12 }}>
                      {' '}
                      <CheckCircleIcon />{' '}
                    </IconButton>
                  </ITooltip>
                </div>
              </div>
            </Paper>
          )}
        </>
      ) : (
        <a href={documentLink.value} target='_blank' rel='noreferrer'>
          {documentName.value}
        </a>
      )}
    </div>
  );
};

export default DocumentEditor;
